import { useCallback } from "react";
import { useNavigate } from "react-router";

import { useAppDispatch } from "@redux/hooks";
import { navigateToPolicyStep, NewPolicyRoutes } from "@routing/paths";
import {
  saveUnderwritingAnswers,
  showLoadingFrame,
} from "@covertree/new-business-redux";

import {
  HandleSubmition,
  OnSubmitionError,
  OnSubmitionStarted,
  OnSubmitionSuccess,
  UwQuestionsForm,
} from "@covertree/new-business-uw-questions";

export function UnderwritingQuestionsStep() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSubmition = useCallback<HandleSubmition>(
    async ({ policyLevelUW, unitLevelUW }) => {
      await dispatch(
        saveUnderwritingAnswers({
          policyLevelUW,
          unitLevelUW,
        })
      ).unwrap();
    },
    [dispatch]
  );

  const onSubmitionStarted = useCallback<OnSubmitionStarted>(
    () =>
      dispatch(
        showLoadingFrame({
          messages: ["Saving answers"],
          maxLoadTime: 10,
        })
      ),
    [dispatch]
  );

  const onSubmitionSuccess = useCallback<OnSubmitionSuccess>(
    () =>
      navigateToPolicyStep(
        navigate,
        NewPolicyRoutes.CLAIMS_CHECK,
        NewPolicyRoutes.UNDERWRITING_QUESTIONS,
        dispatch
      ),
    [dispatch, navigate]
  );

  const onSubmitionError = useCallback<OnSubmitionError>(
    () =>
      navigateToPolicyStep(
        navigate,
        NewPolicyRoutes.ERROR,
        NewPolicyRoutes.UNDERWRITING_QUESTIONS,
        dispatch
      ),
    [dispatch, navigate]
  );

  return (
    <UwQuestionsForm
      isD2C={false}
      handleSubmition={handleSubmition}
      onSubmitionStarted={onSubmitionStarted}
      onSubmitionSuccess={onSubmitionSuccess}
      onSubmitionError={onSubmitionError}
    />
  );
}
